export default [
  {
    path: '/activity',
    name: 'activity',
    component: () => import('@views/activity/index.vue'),
    meta: {
      title: '登录送邀功币活动'
    }
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('@views/staticPages/notice.vue'),
    meta: {
      title: '公告'
    }
  },
  {
    path: '/lottery',
    name: 'lottery',
    component: () => import('@/views/lottery/index.vue'),
    meta: {
      title: '转盘抽奖活动'
    }
  },
  {
    path: '/addAddress',
    name: 'addAddress',
    component: () => import('@/views/lottery/addAddress.vue'),
    meta: {
      title: '添加收货地址'
    }
  },
  {
    path: '/logistics',
    name: 'logistics',
    component: () => import('@/views/lottery/logistics.vue'),
    meta: {
      title: '物流信息'
    }
  },
  {
    path: '/activity/invite',
    name: 'inviteFriends',
    component: () => import('@views/coins/inviteFriends.vue'),
    meta: {
      title: '邀请好友'
    }
  },
  {
    path: '/activity/cash',// 万元大奖
    name: 'cash',
    component: () => import('@views/activity/cash/index.vue'),
    meta: {
      title: '预约报名'
    }
  },
  {
    path: '/activity/cashVideo',// 学安全知识 送万元金币
    name: 'cashVideo',
    component: () => import('@views/activity/cashVideo/index.vue'),
    meta: {
      title: '学安全知识 送万元金币'
    }
  }
]
